import React from 'react';
import Section from './common/Section';
import ecommerceTemplate from '../assets/ecommerceTemplate.webp';
import hotelMgt2 from '../assets/ecommerceTemplate.webp';
import template from '../assets/template.jpg.webp';
import consulting from '../assets/consulting.jpg';

const Services = () => {
  const services = [
    {
      id: 1,
      image: ecommerceTemplate,
      title: 'E-Commerce Website',
    },
    {
      id: 2,
      image: template,
      title: 'Amazing Website Templates',
    },
    {
      id: 3,
      image: hotelMgt2,
      title: 'Hotel Management Website',
    },
    {
      id: 4,
      image: consulting,
      title: 'Software Development Training and Consulting',
    },
  ];
  return (
    <Section
      title="Services ⚒"
      subtitle="Here are the services that I can provide to my clients. I hope I offer the service that you are looking for. If you don't find something that you are looking for then please reach out to me through any of my social media handles or on whatsapp"
    >
      <div className="grid lg:grid-cols-2">
        {services.map(({ id, image, title }) => (
          <div
            key={id}
            className="flex flex-col items-center justify-center p-5 shadow-lg dark:shadow-gray-100 rounded-xl duration-300 ease-in-out hover:scale-110"
          >
            <img
              src={image}
              alt={title}
              loading="lazy"
              className="w-36 h-36 md:w-44 md:h-44 object-contain"
            />
            <h3 className="mt-5 text-base">{title}</h3>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Services;
